// apps/.../wet/components/SiteScripts.tsx
'use client';

import Script from 'next/script';
import React from 'react';

type Props = {
  gtmId: string;               // e.g., 'GTM-5LJJ36TX'
  siteSection?: string;        // e.g., 'wateredge'
  env?: string;                // e.g., 'production'
  ldOrg?: Record<string, any>;
  ldWebsite?: Record<string, any>;
};

export default function SiteScripts({ gtmId, siteSection = 'wet', env = 'development', ldOrg, ldWebsite }: Props) {
  const seed = {
    event: 'wet_child_boot',
    site_section: siteSection,
    environment: env,
    anonymize_ip: true,
  };

  return (
    <>
      {/* Seed dataLayer before GTM loads */}
      <Script id="dl-seed" strategy="beforeInteractive">{`
        window.dataLayer = window.dataLayer || [];
        window.dataLayer.push(${JSON.stringify(seed)});
      `}</Script>

      {/* GTM (head) */}
      <Script id="gtm" strategy="afterInteractive">{`
        (function(w,d,s,l,i){w[l]=w[l]||[];w[l].push({'gtm.start':
          new Date().getTime(),event:'gtm.js'});var f=d.getElementsByTagName(s)[0],
          j=d.createElement(s),dl=l!='dataLayer'?'&l='+l:'';j.async=true;j.src=
          'https://www.googletagmanager.com/gtm.js?id='+i+dl;f.parentNode.insertBefore(j,f);
        })(window,document,'script','dataLayer','${gtmId}');
      `}</Script>

      {/* Schema.org JSON-LD (kept) */}
      {ldOrg && (
        <Script id="ld-org" type="application/ld+json" dangerouslySetInnerHTML={{ __html: JSON.stringify(ldOrg) }} />
      )}
      {ldWebsite && (
        <Script id="ld-website" type="application/ld+json" dangerouslySetInnerHTML={{ __html: JSON.stringify(ldWebsite) }} />
      )}

      {/* GTM (noscript) – must render in body; Next supports this */}
      <noscript>
        <iframe
          src={`https://www.googletagmanager.com/ns.html?id=${gtmId}`}
          height="0"
          width="0"
          style={{ display: 'none', visibility: 'hidden' }}
        />
      </noscript>
    </>
  );
}
